import { NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { UrlBuilderService } from '../../services/url-builder.service';
import {CommunityPost} from '../../models/community/community-post.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'infinite-scroll',
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.scss'],
  standalone: true,
  imports: [NgIf, TranslateModule]
})
export class InfiniteScrollComponent implements OnInit, AfterViewInit {

  @Input()
  listType: 'Posts' | 'Members' | 'Comments' | 'Notifications' = 'Posts';

  @Input()
  loading: boolean;

  @Input()
  postsLength: number = 0;

  @Input()
  post: CommunityPost;

  @Input()
  hasMore: boolean = true;

  @Output()
  loadMore: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('scrollContainer')
  scrollContainer: ElementRef;

  loadingGif: string;

  private observer: IntersectionObserver;

  constructor(private ub: UrlBuilderService) {}

  ngOnInit(): void {

    this.loadingGif = this.ub.buildImageUrl('/images/community/spinner.gif');

  }

  ngAfterViewInit() {

    this.observer = new IntersectionObserver(entries => {

      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading && this.hasMore) {
          this.loadMore.emit();
        }
      }, {
        threshold: 0.01 // Set a very low threshold value
      });
    });

    this.observer.observe(this.scrollContainer.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
